import { ListArPaymentDetailsByProResp } from '@xpo-ltl-2.0/sdk-accountsreceivable';

export class PaymentHistoryData {
  pickupDate: any;
  arrPayDet: ListArPaymentDetailsByProResp;
  custMadCd: string;
}
